import { render, staticRenderFns } from "./SecondSponsorsByDwellTime.vue?vue&type=template&id=aed46c7a&"
import script from "./SecondSponsorsByDwellTime.vue?vue&type=script&lang=js&"
export * from "./SecondSponsorsByDwellTime.vue?vue&type=script&lang=js&"
import style0 from "./SecondSponsorsByDwellTime.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports